import styled from "styled-components";
import { colors, darkModeColors, fonts } from "../../consts";
import { WrapperContainer, Paragraph2, Heading5 } from "..";
import { WhiteContainer } from "../Containers/styled";
import { device } from "../../services";

export const ChartWrapper = styled(WrapperContainer)`
  font-family: ${fonts.PLUS_JAKARTA_SANS};

  font-size: 10px;
  line-height: 14px;
  font-weight: 500;

  .rechart-zero-maxY-line {
    transform: translateY(-112px);
  }

  .rechart-zero-maxY-value .recharts-cartesian-axis-ticks {
    transform: translateY(-112px);
  }
`;

export const LegendItemsList = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  gap: 24px;

  li {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    gap: 8px;
    cursor: pointer;

    ${Paragraph2} {
      font-weight: 700;
      font-size: 10px;
      line-height: 14px;
    }

    span {
      font-family: ${fonts.PLUS_JAKARTA_SANS};
      font-weight: 400;
      font-size: 10px;
      line-height: 14px;
    }
  }
`;

export const ColumnLegendWrapper = styled(WrapperContainer)`
  ${LegendItemsList} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ColorIndicator = styled.div`
  width: 8px;
  min-width: 8px;
  height: 8px;
  border-radius: 50%;

  background: ${(props) => (props?.color ? props.color : "transparent")};
`;

export const DashboardTooltipWrapper = styled(WhiteContainer)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: ${darkModeColors.RAISIN_100_WHITE};
  width: 170px;

  box-shadow: unset;
  border-radius: 4px;
`;

export const DashboardTooltipTitleWrapper = styled(WhiteContainer)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  background-color: ${darkModeColors.RAISIN_100_WHITE};

  width: 100%;
  box-shadow: unset;
  padding: 8px;
  border-radius: 0;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;

  border-bottom: 1px solid ${colors.RAISIN_80};

  ${Paragraph2} {
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    color: ${darkModeColors.WHITE_RAISIN_100};
  }

  span {
    font-size: 22px;
    font-style: normal;
    font-weight: 800;
    line-height: 32px;
    color: ${darkModeColors.WHITE_RAISIN_100};
  }
`;

export const AttributesList = styled.ul`
  margin-top: 4px;
  padding: 0 8px 8px;
  width: 100%;

  ${Paragraph2} {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
  }
`;

export const AttributeItem = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;

  gap: 4px;

  ${Paragraph2} {
    display: flex;
    justify-content: space-between;
    color: ${colors.RAISIN_10};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
  }
  span {
    color: ${darkModeColors.WHITE_RAISIN_100};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
`;

export const AttributeItemTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RadialChartContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 12px 42px;

  @media screen and ${device.notebook} {
    flex-direction: column;
  }

  .recharts-layer path {
    ${(props) => props.stroke && "stroke: transparent"};
  }

  .container {
    position: relative;
  }

  .svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-1deg);
  }

  *:focus {
    outline: none;
  }
`;

export const RadialCartTotalTitle = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: ${colors.RAISIN_70};

  ${Heading5} {
    font-family: ${fonts.PLUS_JAKARTA_SANS};
    font-size: 22px;
    font-style: normal;
    font-weight: 800;
    line-height: 32px;
  }
`;

export const RadialTooltipContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 8px;
  border-radius: 2px;
  background-color: ${darkModeColors.RAISIN_100_WHITE};
  color: ${darkModeColors.WHITE_RAISIN_100};
  font-family: ${fonts.PLUS_JAKARTA_SANS};
`;

export const RadialTooltipValues = styled.div`
  display: flex;
  align-items: center;
  gap: 35px;
  justify-content: space-between;

  p {
    font-size: 22px;
    font-style: normal;
    font-weight: 800;
    line-height: 32px;
    color: ${darkModeColors.WHITE_RAISIN_100};
  }
`;

export const RadialTooltipTotal = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    font-family: ${fonts.PLUS_JAKARTA_SANS};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    color: ${colors.RAISIN_40};
  }
`;

export const RadialChartWrapper = styled.div`
  width: ${(props) => props.width && props.width}px;
  height: ${(props) => props.height && props.height}px;
`;

export const NoInfo = styled.div`
  height: ${(props) => props.height ?? props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 12px;
`;
